import { VFlex } from '../VFlex';
import { VAggregationSelectField } from './VAggregationSelectField';
import {
  VDateNavigationNextButton,
  VDateNavigationPrevButton,
} from './VDateNavigationButtons';
import { VDatePickerField } from './VDatePickerField';
import { VPeriodSelectorContextProvider } from './VPeriodSelectorContextProvider';
import { VPeriodUnit } from './VPeriodUnit';
import { VRangePivot } from './VRangePivot';
import {
  useInitializeDateRangeOnPivotChange,
  useVPeriodSelectorContext,
} from './hook';
import type { VPeriodSelectorProps } from './type';

export const VPeriodSelector = <T extends boolean>(
  props: VPeriodSelectorProps<T>,
) => {
  return (
    <VPeriodSelectorContextProvider<T> {...(props as any)}>
      <VInnerPeriodSelector<T> />
    </VPeriodSelectorContextProvider>
  );
};

const VInnerPeriodSelector = <T extends boolean>() => {
  const { rangePivot, onDateRangeChange } = useVPeriodSelectorContext<T>();

  useInitializeDateRangeOnPivotChange({
    rangePivot,
    onDateRangeChange,
  });

  return (
    <VFlex
      className="w-fit"
      data-testid="v-period-selector"
      items="center"
      justify="between"
      gap={0.25}
    >
      <VFlex
        className="flex-1"
        justify="end"
        data-testid="v-period-selector-unit"
      >
        <VPeriodUnit />
      </VFlex>

      <VFlex gap={0.25} items="center" data-testid="v-period-selector-nav">
        <VDateNavigationPrevButton />
        <VRangePivot />
        <VAggregationSelectField />
        <VDatePickerField />
        <VDateNavigationNextButton />
      </VFlex>
    </VFlex>
  );
};

VPeriodSelector.displayName = 'VPeriodSelector';
VInnerPeriodSelector.displayName = 'VInnerPeriodSelector';
